export interface CookieConsent {
  essential: boolean;
  analytics: boolean;
  marketing: boolean;
  timestamp: number;
  version: string;
}

export interface CookieCategory {
  id: keyof Omit<CookieConsent, 'timestamp' | 'version'>;
  name: string;
  description: string;
  required: boolean;
  cookies: string[];
}

export const COOKIE_CATEGORIES: CookieCategory[] = [
  {
    id: 'essential',
    name: 'Essential Cookies',
    description: 'These cookies are necessary for the website to function and cannot be switched off. They are usually only set in response to actions made by you which amount to a request for services.',
    required: true,
    cookies: ['session', 'security', 'preferences']
  },
  {
    id: 'analytics',
    name: 'Analytics Cookies',
    description: 'These cookies help us understand how visitors interact with our website by collecting and reporting information anonymously.',
    required: false,
    cookies: ['_ga', '_ga_*', '_gid', '_gat']
  },
  {
    id: 'marketing',
    name: 'Marketing Cookies',
    description: 'These cookies are used to track visitors across websites to display relevant advertisements and marketing campaigns.',
    required: false,
    cookies: ['_fbp', '_fbc', 'fr']
  }
];

export const CONSENT_VERSION = '1.0';
export const CONSENT_EXPIRY_DAYS = 365;
export const LOCAL_STORAGE_KEY = 'nitro-cookie-consent';
